/**
 * JS represents application entry point with specification of module dependencies.
 */

// import css and images (important for webpack)
import '../images/icon.ico';
import '../images/icon.png';

import pcLogo from '../images/pc-logo.png';
import mobileLogo from '../images/mobile-logo.png';

const header = {
	pc: { logo: pcLogo },
	tablet: { logo: mobileLogo },
	mobile: { logo: mobileLogo }
};

import Template from './template';
import { init } from 'simplifyworks-core-ui';
import kopla from 'simplifyworks-kopla-ui';

let modules = [kopla];

// init application with specified modules and customization
init({ Template, systemModules: [], modules: modules, header });
